export default __webpack_public_path__ + "static/media/icons8-virtual-reality-100.a10d6f22.svg";